<template>
  <v-container class="fill-height justify-center" fluid>
    <v-card tile width="500">
      <v-card-title>
        <span class="headline">{{ $t("loginTitle") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @keyup.native.enter="submit">
          <v-text-field
            placeholder=" "
            label="E-mail"
            name="email"
            prepend-icon="mdi-account"
            type="text"
            v-model="authData.email"
            :error-messages="emailErrors"
            required
            @input="$v.authData.email.$touch()"
            @blur="$v.authData.email.$touch()"
          ></v-text-field>
          <v-text-field
            placeholder=" "
            :label="$t('loginPassword')"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            v-model="authData.password"
            :error-messages="passwordErrors"
            required
            @input="$v.authData.password.$touch()"
            @blur="$v.authData.password.$touch()"
          ></v-text-field>
          <small>* {{ $t("validation") }}</small>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-dialog v-model="restoreDialog" persistent max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text>{{
              $t("resetPasswordLink")
            }}</v-btn>
          </template>
          <v-card tile>
            <v-card-title>
              <span class="headline">{{ $t("resetPasswordTitle") }}</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                :label="'E-mail *'"
                name="email"
                type="text"
                required
                v-model="restoreEmail"
                :error-messages="restoreEmailErrors"
                @input="$v.restoreEmail.$touch()"
                @blur="$v.restoreEmail.$touch()"
              ></v-text-field>
              <small>* {{ $t("validation") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                :disabled="$v.restoreEmail.$invalid"
                text
                @click="
                  requestToResetPassword({ email: restoreEmail }),
                    (restoreDialog = false)
                "
                >{{ $t("btnApply") }}</v-btn
              >
              <v-btn color="red darken-1" text @click="restoreDialog = false">{{
                $t("btnCancel")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="$v.authData.$invalid"
          color="green darken-1"
          text
          @click="submit"
          >{{ $t("btnEnter") }}</v-btn
        >
        <v-btn color="red darken-1" text @click="clear">{{
          $t("btnClear")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "Login",

  mixins: [validationMixin],

  validations: {
    authData: {
      email: { required, email },
      password: { required },
    },
    restoreEmail: { required, email },
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.authData.email.$dirty) return errors;
      !this.$v.authData.email.email &&
        errors.push(this.$i18n.t("validationEmail"));
      !this.$v.authData.email.required &&
        errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.authData.password.$dirty) return errors;
      !this.$v.authData.password.required &&
        errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
    restoreEmailErrors() {
      const errors = [];
      if (!this.$v.restoreEmail.$dirty) return errors;
      !this.$v.restoreEmail.email &&
        errors.push(this.$i18n.t("validationEmail"));
      !this.$v.restoreEmail.required &&
        errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
  },

  data: () => ({
    authData: {
      email: "",
      password: "",
    },
    restoreDialog: false,
    restoreEmail: "",
  }),

  methods: {
    ...mapActions(["logIn", "requestToResetPassword"]),
    submit() {
      this.$v.$touch();
      if (!this.$v.authData.$invalid) {
        this.logIn(this.authData);
      }
    },
    clear() {
      this.$v.$reset();
      this.authData.email = "";
      this.authData.password = "";
    },
  },
};
</script>
